module.exports = __webpack_public_path__ + "img/logo_argo.927bf69b.svg";